import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17716 15636"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:196.328}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974347716400">
        <rect
          width={1992}
          height={7970}
          x={7862}
          y={98}
          className="fill stroke1"
          style={{
            strokeWidth: 196.328,
          }}
          rx={996}
          ry={535}
        />
        <rect
          width={9089}
          height={67715}
          className="fill stroke1"
          style={{
            strokeWidth: 196.328,
          }}
          rx={4545}
          ry={4545}
          transform="matrix(-.1096 -.18983 .10193 -.05885 728.821 15903.5)"
        />
        <rect
          width={9089}
          height={67715}
          className="fill stroke1"
          style={{
            strokeWidth: 196.328,
          }}
          rx={4545}
          ry={4545}
          transform="matrix(-.1096 .18983 -.10193 -.05885 17983.2 14178)"
        />
        <path
          d="M8858 9064c-550 0-996 446-996 996s446 996 996 996 996-446 996-996-446-996-996-996z"
          className="fill stroke1"
          style={{
            strokeWidth: 196.328,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
